import { z } from "zod";

export const BulkApplyMergeEntrySchema = z.object({
  target_bookmark_names: z.array(z.string()),
  target_ooxml_after: z.array(z.string()),
  rule_uuids: z.array(z.string()).optional(),
  rule_names: z.array(z.string()).optional(),
});

export type BulkApplyMergeEntry = z.infer<typeof BulkApplyMergeEntrySchema>;
